export default __webpack_public_path__ + "static/media/crackers-wide@2x.57606bb0.jpg";